import(/* webpackMode: "eager" */ "/vercel/path0/src/app/shop/page.tsx");
